import * as React from 'react';

import { BaseExercisePage } from '../baseExercisePage';
import { Align } from './align';
import * as Edge from '../../../core';
import AlignResults from './results';
import AlignConfigForm from './configForm';

export default class AlignPage extends BaseExercisePage<
	Edge.Models.AlignmentExerciseConfiguration,
	Edge.Models.AlignmentExerciseResult
> {
	protected renderConfiguration(): JSX.Element {
		const { lockConfiguration, operationName, mode } = this.props;
		const { configuration } = this.state;

		return (
			<AlignConfigForm
				mode={mode}
				operationName={operationName}
				onSubmit={this.startExercise}
				initialConfiguration={configuration}
				lockConfiguration={lockConfiguration}
			/>
		);
	}
	protected renderExercise(): JSX.Element {
		const { currentProfile } = this.props;
		const { configuration, fullScreen } = this.state;

		return (
			<Align
				mode="evaluate"
				debugMode={this.props.debugMode}
				renderScale={currentProfile.renderScale}
				touchControls={currentProfile.touchControls}
				fullScreen={fullScreen!}
				completeExercise={this.finishExercise}
				abortingExercise={this.abortingExercise}
				configuration={configuration}
			/>
		);
	}
	protected renderResults(): JSX.Element {
		const { hideExerciseResults } = this.props;

		return (
			<AlignResults
				results={this.state.result!}
				complete={this.complete}
				retry={this.retryExercise}
				completeText={this.props.completeText}
				hideExerciseResults={hideExerciseResults}
			/>
		);
	}
}
